
define('text!templates/content/reseller_licenses.html',[],function () { return '<div class="panel panel-transparent">\n    <div class="panel-body">\n        <div class="purchase-information-container">\n\n        </div>\n        \n        <div class="main-list-container">\n\n        </div>\n    </div>\n</div>\n';});

